import { createContext } from "preact";
import { useContext } from "preact/hooks";

export type Popup =
	| { kind: "spell"; spellId: string; circle: number | null; name: string; preview?: boolean }
	| { kind: "xp" }
	// A past level's number resolves what it left pending; absent, the next level is raised.
	| { kind: "level_up"; level?: number }
	| { kind: "catalog" }
	| { kind: "item_new" }
	| { kind: "item_edit"; itemId: string }
	// The compact spell picker on its own, and the grimório checklist; both for a character who memorizes spells.
	| { kind: "spells" }
	| { kind: "grimoire" }
	| { kind: "rest" }
	| { kind: "agonize" }
	| { kind: "rolls" }
	// The portrait picker, for a character whose viewer may edit it.
	| { kind: "portrait" };

export type OpenPopup = { popup: Popup; opener: HTMLElement | null };

// What opens a popup; the sheet keeps at most one.
export const PopupContext = createContext<((popup: Popup, opener: HTMLElement | null) => void) | null>(null);

export const useOpenPopup = () => useContext(PopupContext);
